export class RegisterUserFromLeadRequest {
    email: string;
}